import React from 'react';
import './index.less';
import _ from 'lodash';
import { connect } from 'dva';
import ABSPanel from '../../ABSPanel';
import ABSFileList from '../../ABSFileList';
import ABSNoContent from '../../ABSNoContent';
import ABSContainer from '../../ABSContainer';
import ABSPagination from '../../ABSPagination';
import commonUtils from '../../../utils/commonUtils';

export interface IABSNewsProps {
  className?: string;
  actionType: string;
  title: string;
  payload: Object;
  model: string;
  comment?: any;

  loading?: boolean;
  newsList?: INewsList;
  renderRow: (item: any) => Object;
  dispatch?: any;
}

export interface INewsList {
  items: INewsListItem[];
}

export interface INewsListItem {
  title: string;
  source: string;
  publishDate: string;
  url: string;
}

export interface IABSNewsState { }

class ABSNews extends React.Component<IABSNewsProps, IABSNewsState> {
  private payload;

  constructor(props: any) {
    super(props);
    this.payload = this.props.payload;
  }
  
  componentDidMount() {
    this.onInit();
  }

  componentWillReceiveProps(nextProps: any) {
    const { payload } = nextProps;
    if (!commonUtils.isEqual(this.payload, payload)) {
      this.payload = payload;
      this.onInit();
    }
  }

  renderList() {
    const { newsList, loading, renderRow } = this.props;
    if (!newsList || !newsList.items || newsList.items.length === 0) {
      return <ABSNoContent />;
    }

    let data: any = newsList.items.map((item, index) => {
      return renderRow(item);
    });
    return <ABSFileList list={data} loading={loading} pageSize={10} />;
  }

  render() {
    const { title, actionType, model, comment } = this.props;
    return (
      <div className="abs-news-list-container">
        <ABSContainer
          className="abs-news-list-container-warpper"
          removePerfectScrollBar={true}
        >
          <ABSPanel title={title} removePadding={true} hasBorder={true} comment={comment}>
            {this.renderList()}
          </ABSPanel>
        </ABSContainer>
        <div className="abs-list-container-footer">
          <ABSPagination
            className="abs-deal-list-pagination"
            actionType={actionType}
            payload={this.payload}
            model={model}
          />
        </div>
      </div>
    );
  }

  onInit = () => {
    const { dispatch, actionType } = this.props;
    if (!this.payload) {
      return;
    }
    dispatch({
      type: actionType,
      payload: { ...this.payload, page_index: 1, page_size: 10 }
    });
  }
}

const mapStateToProps = (state, { model, actionType }) => {
  const loading = state.loading.effects[actionType];
  return {
    loading,
    newsList: _.get(state, model)
  };
};
export default connect(mapStateToProps)(ABSNews);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ABSListRowsContainer/ABSNews/index.tsx